import {http} from "@/assets/utils/api";

/**
 * 获取试卷列表
 */
export const getExaminationList = (params) => http.get('/yymPaperDocument/getList',{params});

/**
 * 获取试卷档案信息
 */
export const getExaminationInfo = (paperDocumentId) => http.get(`/yymPaperDocument/getPaperDocument/${paperDocumentId}`);

/**
 * 获取试卷
 */
export const getExamPaperInfo = (paperId) => http.get(`/yymPaperDocument/getByPaperId/${paperId}`,{custom: {isTimeout: true}});

/**
 * 试卷收藏
 */
export const collectPaper = (data) => http.post('/yymPaperCollection/add',data);

/**
 * 试卷取消收藏
 */
export const cancelCollectPaper = (paperId) => http.post(`/yymPaperCollection/delete/${paperId}`);

/**
 * 试卷下载
 */
export const downloadPaper = (data) => http.post('/yymCourseQuestionExamPaper/download',data);

/**
 * 试卷下单
 */
export const placePaperOrder = (paperDocumentId) => http.post(`/yymPaperDocument/order/${paperDocumentId}`);

/**
 * 获取支付二维码
 */
export const getPaperOrderQrcode = (data) => http.post('/yymPaperDocument/getPayQrcode',data);

/**
 * 试卷购买订单状态实时查询
 */
export const checkPaperOrderIspay = (orderNo) => http.get(`/yymPaperDocument/pay/${orderNo}`);

/**
 * 试卷收藏列表
 */
export const getCollectPaperList = (data) => http.post('/yymPaperDocument/getCollectList',data);

/**
 * 我的试卷列表
 */
export const getMyPaperList = (data) => http.post('/yymPaperDocument/getMyBuyList',data);

/**
 * 试卷类型
 */
export const getExamPaperType = () => http.get('/yymPaperType/getAll');

/**
 * 获取试卷订单列表
 */
export const getExamPaperList = (params) => http.get('/yymPaperDocument/getOrderList',{params});

/**
 * 试卷提交（通用---除考试外）
 */
export const saveExamPaper = (data) => http.post('/yymPaperDocument/savePaperRecord',data,{custom: {isTimeout: true}});

/**
 * 作答记录详情（通用---除考试外）
 */
export const getExaminationRecordPaper = (recordId) => http.get(`/yymPaperDocument/getRecordDetail/${recordId}`);

/**
 * 获取试卷列表（多学科）
 */
export const getExaminationListBySubjects = (params) => http.get('/yymPaperDocument/getLists',{params});

/**
 * 多学科统计
 */
export const getExaminationListInfoBySubjects = (subjectIds) => http.get(`/yymPaperDocument/getPaperCounts/${subjectIds}`);

/**
 * 试卷分析
 */
export const examinationAnalysis = (paperId) => http.get(`/yymPaperDocument/analysis/${paperId}`);

/**
 * 知识点列表
 */
// export const getKnowledgeList = () => http.get('/yymCourseKnowledge/getAll');

/***
 * 记录试卷下载次数
 */
export const recordExaminationDownload = (data) => http.post('/yymCourseQuestionExamPaper/download/record',data);

/**
 * 章节查询
 */
export const getChapterAll = (params) => http.get('/yymCourseTextbookChapter/getAll',{params});

/**
 * 知识点查询
 */
export const getKnowledgeAll = (params) => http.get('/yymCourseKnowledge/getAll',{params});

/**
 * 根据学科查询题型列表
 */
export const getQuestionTypeList = (subjectId) => http.get(`/yymCourseQuestionType/type/list/bySubjectWithTotalCount/${subjectId}`);

/**
 * 随即组卷生成
 */
export const generateRandomPaper = (data) => http.post('/yymCourseQuestionExamPaper/random/create',data,{custom: {isTimeout: true}});

/**
 * 获取随机组卷试卷详情
 */
export const getRandomPaperDocument = (buyerPaperDocumentId) => http.get(`/yymBuyerPaperDocument/getPaperDocument/${buyerPaperDocumentId}`,{custom: {isTimeout: true}})